import groupBy from 'lodash/groupBy'

import { type StoreState, useStore } from '~/store/store'
import { selectActiveDepartment, selectLocation, selectPractitioner } from '~/storm'

import { saveStatuses } from './saveStatuses'
import { DatePractitionerCell } from './utils'

// note that we should get this from the backend/config, but hardcoding for now
const DAY_SURGERY_ROOM_CODES = new Set(['OP08', 'OP09', 'OP11', 'OP12', 'OP14'])

type DatePractitionerLocationCell = DatePractitionerCell & { locationId: number }

type AutoAssignStatuses = 'SURGERY' | 'DAY_SURGERY'

export const selectAutoAssignStatus = (state: StoreState, { locationId, practitionerId }: DatePractitionerLocationCell): AutoAssignStatuses | undefined => {
    const location = selectLocation(state, { where: { id: locationId } })
    const practitioner = selectPractitioner(state, { where: { id: practitionerId }, include: { departments: true } })

    if (!location || !practitioner) return

    const activeDepartment = selectActiveDepartment(state)
    const departmentName = activeDepartment === 'Alle' ? practitioner.departments[0]?.name : activeDepartment?.name

    if (departmentName === 'ØNH') return 'SURGERY'

    return DAY_SURGERY_ROOM_CODES.has(location.room_code) ? 'DAY_SURGERY' : 'SURGERY'
}

export const autoAssignStatuses = async (cells: DatePractitionerLocationCell[]) => {
    const cellsWithStatus = cells.flatMap(cell => {
        const status = selectAutoAssignStatus(useStore.getState(), cell)
        return status ? [{ cell, status }] : []
    })

    const groupedByStatus = groupBy(cellsWithStatus, p => p.status)

    const promises = Object.entries(groupedByStatus).map(([status, groupedCells]) =>
        saveStatuses(
            status,
            groupedCells.map(p => p.cell)
        )
    )

    await Promise.all(promises)
}
